import React from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';

import './custom.css'
import { Banners } from './components/exercises/Banners';
import { Sports } from './components/exercises/Sports';
import { Validation } from './components/exercises/Validation';

export default function App() {
    return (
        <Layout>
            <Route exact path='/' component={Home} />
            <Route path="/banners" component={Banners} exact />
            <Route path="/sports" component={Sports} />
            <Route path="/validation" component={Validation} />
        </Layout>
    );
}
